import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import '@alpine-iq/ui-library/styles/main.css';
import './index.css';

import ErrorBoundary from './components/ErrorBoundary';
import LoadingScreen from './components/LoadingScreen';

const rootElement = document.getElementById('root');
if (!rootElement) {
	throw new Error('Root element not found');
}
const root = ReactDOM.createRoot(rootElement);

// IF is not a production build then enable React Strict Mode
const isProduction = process.env.NODE_ENV === 'production';
const StrictWrapper = isProduction ? React.Fragment : React.StrictMode;

root.render(
	<StrictWrapper>
		<ErrorBoundary>
			<React.Suspense fallback={<LoadingScreen />}>
				<App />
			</React.Suspense>
		</ErrorBoundary>
	</StrictWrapper>,
);

reportWebVitals();
